import { alertData as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        msg: '',
        isShow: false,
        callback: null,
        isShowCancelBtn: false,
    },
    // getters,
    actions: {
        setMsg({ commit }, val) {
            commit(types.setMsg, val);
        },
        setIsShow({ commit }, val) {
            commit(types.setIsShow, val);
        },
        setCallback({ commit }, val) {
            commit(types.setCallback, val);
        },
        setIsShowCancelBtn({ commit }, val) {
            commit(types.setIsShowCancelBtn, val);
        },
    },
    mutations: {
        [types.setMsg]: (state, data) => {
            state.msg = data;
        },
        [types.setIsShow]: (state, data) => {
            state.isShow = data;
        },
        [types.setCallback]: (state, data) => {
            state.callback = data;
        },
        [types.setIsShowCancelBtn]: (state, data) => {
            state.isShowCancelBtn = data;
        },
    },
};
